import { CircularProgress } from "@material-ui/core";
import { useContacts } from "modules/app/contexts";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { API } from "shared/services";

import { ButtonSnoozed, StatusBarSnoozed } from "./../styles";

function SnoozedBar({ customer }) {
  const { updateCurrentContact } = useContacts();
  const [loading, setLoading] = useState(false);

  function snoozeContact() {
    setLoading(true);

    const data = {
      customer: {
        status: "snoozed",
      },
    };

    API.put(`customers/${customer.id}`, data)
      .then(() => {
        updateCurrentContact({
          ...customer,
          status: "snoozed",
        });

        toast.success("Sucesso");
      })
      .catch(() => toast.error("Falha"))
      .finally(() => setLoading(false));
  }

  return (
    <StatusBarSnoozed>
      <ButtonSnoozed onClick={() => snoozeContact()} disabled={loading}>
        {loading ? (
          <CircularProgress size={12} color="inherit" />
        ) : (
          "Remover da aba a fazer"
        )}
      </ButtonSnoozed>
    </StatusBarSnoozed>
  );
}

export default SnoozedBar;
